import React from 'react';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { DebriefAircraft } from 'ff/debrief/models';
import { useGetAircraftListQuery } from 'ff/debrief/features/TracklogApi';

interface Props {
    value: DebriefAircraft;
    onChange: (newValue: DebriefAircraft) => void;
    disabled?: boolean;
}

const AircraftModelField = (props: React.PropsWithChildren<Props>) => {
    const [inputValue, setInputValue] = React.useState('');

    const { data: aircraftModels, isLoading } =
        useGetAircraftListQuery(inputValue);

    const handleChange = (
        evt: React.SyntheticEvent,
        newValue: DebriefAircraft
    ) => {
        props.onChange(newValue);
    };

    const handleInputChange = (evt: React.SyntheticEvent, newValue: string) => {
        setInputValue(newValue);
    };

    return (
        <Autocomplete
            sx={{ flexGrow: 1.5 }}
            options={aircraftModels || []}
            value={props.value}
            inputValue={inputValue}
            onChange={handleChange}
            onInputChange={handleInputChange}
            filterOptions={x => x}
            loading={isLoading}
            disabled={props.disabled}
            disableClearable
            renderInput={params => (
                <TextField {...params} label="Aircraft" variant="standard" />
            )}
        />
    );
};

export default AircraftModelField;
